export enum UsersEvent {
    BulkInvite = 'Users.BulkInvite',
    Invited = 'Users.Invited',
    AcceptedInvitation = 'User.AcceptedInvitation',
    Delete = 'Users.Delete',
}
